// Mirrors the list Amplify uses to drop its stored tokens
// (`TokenOrchestrator.handleErrors`), so anything outside it leaves a session
// the SDK still considers usable.
const AUTH_FAILURE_ERROR_NAMES = [
  'UserUnAuthenticatedException',
  'NotAuthorizedException',
  'TokenRevokedException',
  'RefreshTokenReuseException',
  'UserNotFoundException',
  'PasswordResetRequiredException',
  'UserNotConfirmedException',
]

const getErrorName = (error: unknown): string => {
  if (
    typeof error === 'object' &&
    error !== null &&
    'name' in error &&
    typeof error.name === 'string'
  ) {
    return error.name
  }

  return ''
}

export const isAuthFailure = (error: unknown): boolean => {
  const name = getErrorName(error)

  // Amplify prefixes some service errors with the operation name
  return AUTH_FAILURE_ERROR_NAMES.some(failureName =>
    name.startsWith(failureName),
  )
}
